import formAPIfastingbloodglucose from "./fastingsugar";


var formattedOutput = null;

const formAPIModelfastingbloodglucose = (data, type) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIfastingbloodglucose(item, type));


  return formattedOutput
};

export default formAPIModelfastingbloodglucose